import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const UbuntuColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      fill="#F47421"
    />
    <path
      d="M9.57071 3.41048C9.31266 3.85744 9.4658 4.42897 9.91276 4.68702C10.3597 4.94507 10.9312 4.79193 11.1893 4.34497C11.4474 3.89801 11.2942 3.32648 10.8472 3.06843C10.4003 2.81038 9.82876 2.96352 9.57071 3.41048Z"
      fill="white"
    />
    <path
      d="M4.1745 8C4.1745 8.51611 3.75611 8.93449 3.24 8.93449C2.7239 8.93449 2.30551 8.51611 2.30551 8C2.30551 7.4839 2.7239 7.06551 3.24 7.06551C3.75611 7.06551 4.1745 7.4839 4.1745 8Z"
      fill="white"
    />
    <path
      d="M9.91275 11.313C10.3597 11.0549 10.9312 11.2081 11.1893 11.655C11.4473 12.102 11.2942 12.6735 10.8472 12.9316C10.4003 13.1896 9.82875 13.0365 9.5707 12.5895C9.31265 12.1426 9.46579 11.571 9.91275 11.313Z"
      fill="white"
    />
    <path
      d="M9.72374 5.0144C9.3681 4.80907 9.14491 4.46244 9.08413 4.08636C8.73902 3.99097 8.37546 3.94 7.99999 3.94C7.35023 3.94 6.73611 4.09264 6.19155 4.36402L6.85857 5.51935C7.20587 5.35928 7.5925 5.27 7.99999 5.27C9.42282 5.27 10.5914 6.35848 10.7185 7.74817H12.0523C11.9891 6.71503 11.5395 5.78632 10.8462 5.1047C10.4904 5.23966 10.079 5.21952 9.72374 5.0144Z"
      fill="white"
    />
    <path
      d="M7.99999 12.06C8.37546 12.06 8.73903 12.009 9.08415 11.9136C9.14493 11.5376 9.36812 11.1909 9.72376 10.9856C10.079 10.7805 10.4904 10.7604 10.8462 10.8953C11.5395 10.2137 11.9891 9.28497 12.0523 8.25183H10.7185C10.5914 9.64152 9.42283 10.73 7.99999 10.73C7.59251 10.73 7.20588 10.6407 6.85859 10.4807L6.19156 11.636C6.73612 11.9074 7.35023 12.06 7.99999 12.06Z"
      fill="white"
    />
    <path
      d="M4.55252 8C4.55252 8.41065 4.36394 8.77725 4.06865 9.01792C4.32212 9.99967 4.93363 10.8375 5.75561 11.3838L6.42263 10.2285C5.72517 9.73388 5.26999 8.9201 5.26999 8C5.26999 7.07991 5.72516 6.26613 6.42261 5.77156L5.75559 4.61624C4.93362 5.16254 4.32212 6.00034 4.06865 6.98209C4.36394 7.22276 4.55252 7.58936 4.55252 8Z"
      fill="white"
    />
  </Icon>
));

export default UbuntuColor;
